export default __webpack_public_path__ + "static/media/play.1d92ff3d.svg";